import React from 'react';
export function CredibilitySection() {
  return <section className="py-20 px-4 bg-[#141414]" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <div className="flex items-center gap-4 mb-8" data-id="element-23">
          <div className="h-px bg-[#2a2a2a] flex-1" data-id="element-24"></div>
          <h2 className="text-3xl font-serif text-[#C9A84C]" data-id="element-25">
            Por qué escribí esto
          </h2>
          <div className="h-px bg-[#2a2a2a] flex-1" data-id="element-26"></div>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-[#9a9a9a] leading-relaxed font-light" data-id="element-27">
          <p data-id="element-28">
            Me llamo <strong className="text-white" data-id="element-29">Roderic Guillen</strong>. No
            hace mucho, desperté en una unidad de cuidados intensivos con una
            cicatriz en el pecho después de{' '}
            <strong className="text-white" data-id="element-30">seis bypass coronarios</strong>. Los
            médicos me salvaron la vida—pero me quedó una pregunta que quemaba:{' '}
            <em className="text-[#C9A84C]" data-id="element-31">
              ¿Cómo llegué aquí si yo creía que me cuidaba?
            </em>
          </p>
          <p data-id="element-32">
            En EE. UU., el sistema médico es excelente para intervenir cuando ya
            estás en la camilla… pero casi nunca tiene el tiempo para enseñar
            prevención con profundidad. Por eso me metí de lleno en la
            investigación—estudios que rara vez llegan a la persona común en un
            lenguaje claro. Ahí encontré un factor silencioso que lo cambia
            todo: <strong className="text-white" data-id="element-33">la glicación</strong>.
          </p>
        </div>
      </div>
    </section>;
}